export const styles = {
  container: 'tw-flex tw-flex-col tw-gap-2 tw-p-6',
  header: 'tw-flex tw-items-center tw-justify-between',
  title: 'tw-text-3xl tw-font-bold tw-text-white-800 tw-flex tw-items-center tw-gap-4 tw-m-0 tw-leading-none',
  filtersContainer: 'tw-w-full tw-mt-4 tw-mb-2',
  content: 'tw-flex-1 tw-flex tw-gap-4 tw-min-h-0 tw-overflow-hidden',
};
